import { SolanaWalletConnectors } from './solana-wallet-connectors'

export const WalletConnectors: React.FC = () => <SolanaWalletConnectors />
